export enum CUSTOM_MESSAGE_TYPE {
  ACCOUNT_CREATION = 'UC',
  DESIRED_DATE = 'DD',
  INSURANCE_RELATIONSHIP = 'RC',
  INSURANCE_SELECTION = 'SC',
  SCHEDULE_BLOCKING = 'BA'
}
